module.exports = __webpack_public_path__ + "annualreview2018/static/img/governance@2x.c66b8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/governance@2x.png
// module id = DWZG
// module chunks = 10